// Internal modules
import { logger, STATE_NAME, TRANSITION_NAME } from '@/lib/logger';

export const logAppNotFound = (buttonSessionId: string): void => {
  logger.fpti('prepare_app_not_found​', {
    button_session_id: buttonSessionId,
    component: 'checkoutuinodeweb',
    context_type: 'EC-TOKEN',
    state_name: 'venmo_app_not_found_half_sheet​',
    transition_name: 'prepare_app_not_found​',
  });
};

export const logProcessPayWithPayPal = (buttonSessionId: string): void => {
  logger.fpti('process_pay_with_paypal​', {
    button_session_id: buttonSessionId,
    component: 'checkoutuinodeweb',
    context_type: 'EC-TOKEN',
    state_name: 'venmo_app_not_found_half_sheet​',
    transition_name: 'process_pay_with_paypal​',
  });
};

export const logCancelAndRTM = (): void => {
  const { cancelAndRtm } = TRANSITION_NAME;

  logger.fpti(`weasley_${cancelAndRtm}`, {
    state_name: STATE_NAME.backToMerchant,
    transition_name: cancelAndRtm,
  });
};
